var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrameHome1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 76,
    viewBox: "0 0 120 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_480)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 76,
    rx: 38,
    fill: "#D6F379"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 34V30C44 26.8174 45.2643 23.7652 47.5147 21.5147C49.7652 19.2643 52.8174 18 56 18H64C67.1826 18 70.2348 19.2643 72.4853 21.5147C74.7357 23.7652 76 26.8174 76 30V34H84C86.1217 34 88.1566 34.8429 89.6569 36.3431C91.1571 37.8434 92 39.8783 92 42V56.28C81.7585 60.0749 70.922 62.012 60 62C49.078 62.0121 38.2415 60.0751 28 56.28V42C28 39.8783 28.8429 37.8434 30.3431 36.3431C31.8434 34.8429 33.8783 34 36 34H44ZM52 30C52 28.9391 52.4214 27.9217 53.1716 27.1716C53.9217 26.4214 54.9391 26 56 26H64C65.0609 26 66.0783 26.4214 66.8284 27.1716C67.5786 27.9217 68 28.9391 68 30V34H52V30ZM56 50C56 48.9391 56.4214 47.9217 57.1716 47.1716C57.9217 46.4214 58.9391 46 60 46H60.04C61.1009 46 62.1183 46.4214 62.8684 47.1716C63.6186 47.9217 64.04 48.9391 64.04 50C64.04 51.0609 63.6186 52.0783 62.8684 52.8284C62.1183 53.5786 61.1009 54 60.04 54H60C58.9391 54 57.9217 53.5786 57.1716 52.8284C56.4214 52.0783 56 51.0609 56 50Z",
    fill: "#138F01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 64.7681V74.0001C28 76.1218 28.8429 78.1566 30.3431 79.6569C31.8434 81.1572 33.8783 82.0001 36 82.0001H84C86.1217 82.0001 88.1566 81.1572 89.6569 79.6569C91.1571 78.1566 92 76.1218 92 74.0001V64.7681C81.6894 68.2431 70.8804 70.0104 60 70.0001C49.1196 70.01 38.3107 68.2427 28 64.7681Z",
    fill: "#88CA49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 76,
    rx: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameHome1);
export default __webpack_public_path__ + "static/media/Frame_home_1.c51393990136d066ce413c8831ae995e.svg";
export { ForwardRef as ReactComponent };